module.exports = __webpack_public_path__ + "media/landing_page/investigation-c871f3a8.svg";